import confetti from 'canvas-confetti';

type CelebrationMode = 'confetti' | 'fireworks' | 'stars' | 'school' | 'crazy';

export const triggerConfetti = (options: {
  duration?: number;
  particleCount?: number;
  colors?: string[];
} = {}) => {
  const { particleCount = 100, colors } = options;
  confetti({
    particleCount,
    spread: 70,
    origin: { y: 0.6 },
    colors: colors ?? ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE'],
  });
};

export const triggerFireworks = () => {
  const duration = 3000;
  const end = Date.now() + duration;

  const frame = () => {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: ['#FF6B6B', '#FF8C00', '#FFD700'],
    });
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: ['#4ECDC4', '#45B7D1', '#BB8FCE'],
    });
    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };
  frame();
};

export const triggerStarShower = () => {
  const goldColors = ['#FFD700', '#FFA500', '#FF8C00', '#FFE4B5', '#FFDEAD'];
  const end = Date.now() + 2500;

  const frame = () => {
    confetti({
      particleCount: 3,
      angle: 90,
      spread: 120,
      origin: { x: Math.random(), y: -0.1 },
      colors: goldColors,
      shapes: ['star'],
      scalar: 1.4,
    });
    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };
  frame();
};

export const triggerSchoolPride = (colors = ['#7c3aed', '#f59e0b']) => {
  const end = Date.now() + 2000;

  const frame = () => {
    confetti({
      particleCount: 5,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors,
    });
    confetti({
      particleCount: 5,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors,
    });
    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };
  frame();
};

export const triggerCrazyParty = () => {
  const end = Date.now() + 4000;

  const frame = () => {
    confetti({
      particleCount: 10,
      angle: Math.random() * 360,
      spread: 360,
      origin: {
        x: Math.random(),
        y: Math.random() * 0.6,
      },
      colors: [
        '#FF6B6B', '#FFD700', '#4ECDC4', '#45B7D1',
        '#BB8FCE', '#FF8C00', '#98D8C8', '#F7DC6F',
        '#E74C3C', '#3498DB', '#2ECC71', '#9B59B6',
      ],
      shapes: ['circle', 'square', 'star'],
      scalar: 1.2,
    });
    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };
  frame();
};

export const triggerCelebration = () => {
  confetti({ particleCount: 100, spread: 70, origin: { y: 0.6 } });
  setTimeout(() => confetti({ particleCount: 50, angle: 60, spread: 55, origin: { x: 0 } }), 400);
  setTimeout(() => confetti({ particleCount: 50, angle: 120, spread: 55, origin: { x: 1 } }), 800);
};

export const triggerVictory = () => {
  const goldColors = ['#FFD700', '#FFA500', '#FF8C00', '#FFE4B5', '#FFDEAD'];
  confetti({ particleCount: 150, spread: 60, origin: { y: 0.6 }, colors: goldColors, shapes: ['star'] });
};

export type { CelebrationMode };
